const language = {
	spanish: {
		g_evolution_bold_title:
			"Por más de 10 años, Foresight GPS ha estado desarrollando la herramienta más sofisticada para el control y manejo logístico de activos de todos tipo: y lo logramos. A este software lo hemos llamado: G-Evolution",
		g_evolution_bold_text:
			"G-Evolution es un sistema de gestión y control de activos, flotas y personas basado en geolocalización GPS y GPRS.",
		g_evolution_paragraphs: [
			"Este software puede ser consultado desde cualquier dispositivo porque está desarrollado enteramente con tecnologías cloud, siguiendo los más altos estándares de seguridad y rendimiento.",
			"A través de la web o una aplicación móvil, puede tener todos los datos de una flota vehicular, activos móviles o personas (fuerzas de trabajo o individuos) de forma instantánea.",
			"Con G-Evolution puede manejar todos los aspectos logísticos y de seguridad de una flota de cualquier tamaño y de cualquier tipo de vehículos. Además de tener un amplio catálogo de reportes y tableros para facilitar la toma de decisiones.",
		],
		caracteristicas_gevolution_yellow_title: "Características de G-Evolution",
		caracteristicas_gevolution_bold_title:
			"Con G-Evolution puede manejar todos los aspectos logísticos y de seguridad de una flota de cualquier tamaño y de cualquier tipo de vehículos.",
		caracteristicas_gevolution: [
			{
				text: "Desarrollo cloud. Puede tener acceso desde cualquier dispositivo.",
				column: "1",
			},
			{
				text: "Localización en tiempo real de cualquier activo o persona registrada en la plataforma.",
				column: "1",
			},
			{
				text: "Visibilidad de vehículos sobre mapas digitalizados y fotos satelitales (Google Maps y OSM).",
				column: "1",
			},
			{
				text: "Software llave en mano. No requiere ninguna configuración previa para usarse.",
				column: "1",
			},
			{
				text: "Múltiples dispositivos GPS y sensores compatibles. También podemos hacer homologaciones de dispositivos bajo demanda del cliente o necesidad de la operación.",
				column: "1",
			},
			{
				text: "Experiencia móvil nativa. G-Evolution cuenta con una aplicación disponible para sistemas Android o iOS.",
				column: "2",
			},
			{
				text: "Desarrollos personalizados. Al tener la propiedad del código y ser una fábrica de software estamos en la capacidad de agregar nuevas funcionalidades dependiendo de las necesidad de la operación o el negocio.",
				column: "2",
			},
			{
				text: "Software marca blanca. Podemos personalizar a G-Evolution con todos los elementos de marca de nuestros clientes para hacer la experiencia más personalizada.",
				column: "2",
			},
		],
		caracteristica_banner_section_1: {
			boldText: "Tiempo real",
			text: "El objetivo principal de G-Evolution es el rastreo eficiente y preciso de cualquier activo o persona en las condiciones más adversas. Todo en tiempo real.",
		},
		caracteristica_banner_section_2: {
			boldText: "Flexibilidad",
			text: "G-Evolution se adapta a cualquier operación, no solo por la diversidad de funcionalidades ya desarrolladas, sino por la escalabilidad de nuestro software que nos permite agregar más funcionalidades.",
		},
		caracteristica_banner_section_3: {
			boldText: "Eficiencia",
			text: "La arquitectura de esta aplicación está diseñada para gestionar todos los recursos de forma eficiente sin importar la cantidad de datos que se puedan ingresar a la plataforma.",
		},
		caracteristica_banner_section_4: {
			boldText: "Análisis preciso",
			text: "Todas las funcionalidades implementadas en G-Evolution generan datos que son tratados y almacenados para presentarlos en múltiples tipos de reportes gŕaficos o tabulares. El objetivo es poder tomar decisiones fundamentadas en información precisa.",
		},
		caracteristica_banner_section_5: {
			boldText: "Fácil de usar",
			text: "G-Evolution es una aplicación logística profesional, que fue diseñada tomando las mejores prácticas de la industria. No obstante, cualquier persona con un mínimo de entrenamiento puede sacar el mayor provecho de esta poderosa plataforma.",
		},
		caracteristica_banner_section_6: {
			boldText: "Todo en uno",
			text: "Muchas empresas con complejas dinámicas logísticas y de seguridad o incluso compañías medianas y pequeñas se hace con muchas herramientas para manejar distintas etapas de sus negocios, con G-Evolution esto no tiene sentido porque desde allí se puede manejar toda la complejidad de la operación.",
		},
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_bold_title: "¿Quién puede usar G-Evolution?",
		caracteristicas_paragraphs: [
			"Este sistema está diseñado para cubrir las necesidades de cualquier tipo de negocio que requiera software de alta calidad para la gestión logística y de seguridad usando telemática y tecnología IoT.",
		],
		caracteristicas_checkText: [
			"Empresas grandes con complejos esquemas de distribución de bienes",
			"Pequeñas y medianas empresas con una flota vehicular de cualquier tipo (terrestre o marítima)",
			"Salas de monitoreo y seguridad",
			"Entes gubernamentales con la necesidad de implementar tecnología de geolocalización",
			"Compañías que ofrecen servicios de localización de flotas comerciales o particulares",
		],
		funcionalidades_yellow_title: "Funcionalidades principales",
		funcionalidades_bold_title:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		funcionalidades: [
			{
				text: "Rastreo en tiempo real de personas, mascotas, activos y flotas",
				column: "1",
			},
			{
				text: "App móvil para acceder desde sistemas Android o iOS",
				column: "1",
			},
			{
				text: "Alertas sonoras configurables",
				column: "1",
			},
			{
				text: "Apagado remoto y apertura de puertas de unidades vehiculares",
				column: "1",
			},
			{
				text: "Botón de pánico (SOS)",
				column: "1",
			},
			{
				text: "Respaldo de datos 36 meses",
				column: "1",
			},
			{
				text: "Video en cabina",
				column: "1",
			},
			{
				text: "Central de control de rutas",
				column: "1",
			},
			{
				text: "Tablero administrativo de inteligencia de negocios",
				column: "1",
			},
			{
				text: "Rastreo de teléfonos inteligentes",
				column: "1",
			},
			{
				text: "Administración de usuarios según roles y privilegios",
				column: "1",
			},
			{
				text: "Datos ubicación, velocidad, dirección y más",
				column: "1",
			},
			{
				text: "Software basado en internet, Google Maps u OSM",
				column: "1",
			},
			{
				text: "Creación y administración de Puntos de interés y Geocercas",
				column: "1",
			},
			{
				text: "Reportes de viajes, velocidad, tiempo de uso, horas trabajas, y mucho más",
				column: "2",
			},
			{
				text: "Número elevado de kilómetros por día, por semana o mes",
				column: "2",
			},
			{
				text: "Alertas por infracciones configurables",
				column: "2",
			},
			{
				text: "Gestión de combustible",
				column: "2",
			},
			{
				text: "Informe de mantenimiento y recordatorios",
				column: "2",
			},
			{
				text: "Consumo de combustible",
				column: "2",
			},
			{
				text: "Alertas y eventos por correo electrónico, SMS o push notifications",
				column: "2",
			},
			{
				text: "Entrenamiento de uso de plataforma",
				column: "2",
			},
			{
				text: "Soporte 24/7",
				column: "2",
			},
			{
				text: "Integración de múltiples sensores sin importar modelo y marca",
				column: "2",
			},
			{
				text: "Tablero de diagnóstico de unidades en tiempo real",
				column: "2",
			},
			{
				text: "Módulo de mantenimiento preventivo",
				column: "2",
			},
			{
				text: "Soluciones para concreteras",
				column: "2",
			},
		],
		form_title: "Deseamos ayudarte, contáctanos ahora",
		form_button_text: "ENVÍA TU RESUMEN",
		form_fields: [
			{
				title: "Nombre:",
				requestKey: "nombre",
			},
			{
				title: "Email:",
				requestKey: "email",
			},
			{
				title: "País:",
				requestKey: "pais",
			},
			{
				title: "Apellido:",
				requestKey: "apellido",
			},
			{
				title: "Móvil:",
				requestKey: "movil",
			},
			{
				title: "Empresa:",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "Asunto:",
				requestKey: "asunto",
			},
		],
	},
	english: {
		g_evolution_bold_title:
			"For over 10 years ForesightGPS has been developing the most sophisticated tool for the control and logistic management of assets of all kinds and we succeeded. We called this software G-Evolution.",
		g_evolution_bold_text:
			"G-Evolution is a management and control system for assets, fleets, and people, based on GPS and GPRS geolocation.",
		g_evolution_paragraphs: [
			"This software can be used from any device because of its development being entirely with cloud technology following the highest security and performance standards.",
			"Through the web or mobile app, you can have access to all the data of a vehicle fleet, mobile assets, or people (workforces or individuals) instantly.",
			"With G-Evolution you can handle all the logistical and security aspects of any sized fleet and any type of pf vehicle. In addition, we have a wide catalog of reports and dashboards to facilitate decision making.",
		],
		caracteristicas_gevolution_yellow_title: "G-Evolution Features",
		caracteristicas_gevolution_bold_title:
			"With G-Evolution you can manage all logistical and safety aspects of a fleet of any size and any type of vehicle.",
		caracteristicas_gevolution: [
			{
				text: "Based on cloud development, so it can be accessed from any device.",
				column: "1",
			},
			{
				text: "Real time location of any asset or person registered in the platform.",
				column: "1",
			},
			{
				text: "Vehicle visibility on digitized maps and satellite photos (Google Maps and OSM).",
				column: "1",
			},
			{
				text: "Turnkey software, so it does not require any prior configuration to use.",
				column: "1",
			},
			{
				text: "Multiple compatible GPS devices and sensors, we also approve devices on client demand or need of the operation.",
				column: "1",
			},
			{
				text: "Native mobile experience, G-Evolution has an app available for Android and iOS.",
				column: "2",
			},
			{
				text: "Custom developments, by owning the code and being a software factory, we can add new features depending on the operation or business needs.",
				column: "2",
			},
			{
				text: "White label software, we can customize G-Evolution with the brand of your clients to make a more personalized experience.",
				column: "2",
			},
		],
		caracteristica_banner_section_1: {
			boldText: "Real Time",
			text: "The main objective of G-Evolution is efficient and precise tracking of any asset or person in the most adverse conditions. All in real time.",
		},
		caracteristica_banner_section_2: {
			boldText: "Flexibility",
			text: "G-Evolution is able to adapt to any operation, not only due to the variety of features already developed, but also to the scalability of our software allowing us to add more features.",
		},
		caracteristica_banner_section_3: {
			boldText: "Efficiency",
			text: "The display of this app is designed to manage all resources efficiently regardless of the amount of data entered in the platform.",
		},
		caracteristica_banner_section_4: {
			boldText: "Accurate analysis",
			text: "All the features implemented in G-Evolution generate data that is processed and stored to later present it on multiple types of graphical or tabular reports. The goal is to be able to make informed decisions based on accurate information.",
		},
		caracteristica_banner_section_5: {
			boldText: "Easy to use",
			text: "G-Evolution is a professional logistics app, designed by taking the best working methods of the industry. However, anyone with minimum training can get the most of this powerful platform.",
		},
		caracteristica_banner_section_6: {
			boldText: "All in one",
			text: "Many companies often use different tools to manage different stages of their businesses, all with different and complex logistics and security dynamics. With G-Evolution this will not be a problem since the platform can handle the complexity of any operation.",
		},
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_bold_title: "¿Who can use G-Evolution?",
		caracteristicas_paragraphs: [
			"This system is designed to meet the needs of any type of business that requires high-quality software for logistics and security management using telematics and IoT technology.",
		],
		caracteristicas_checkText: [
			"Large companies with complex distribution schemes",
			"Small and medium sized companies with a vehicle fleet of any size (land or sea)",
			"Monitoring and security rooms",
			"Government entities with the need to use geolocation technology",
			"Companies offering location services for commercial or private fleets",
		],
		funcionalidades_yellow_title: "Main functionalities",
		funcionalidades_bold_title:
			"We have the best technological innovation for optimal tracking of your mobile assets.:",
		funcionalidades: [
			{
				text: "Real time tracking of people, pets, assets and fleets",
				column: "1",
			},
			{
				text: "Mobile app access from Android and iOS",
				column: "1",
			},
			{
				text: "Customizable audible alerts",
				column: "1",
			},
			{
				text: "Remote shutdown and door opening of vehicular units",
				column: "1",
			},
			{
				text: "Panic button (SOS)",
				column: "1",
			},
			{
				text: "Data backup up to 36 months",
				column: "1",
			},
			{
				text: "Cabin video",
				column: "1",
			},
			{
				text: "Route control center",
				column: "1",
			},
			{
				text: "Business intelligence administrator dashboard",
				column: "1",
			},
			{
				text: "Smartphone tracking",
				column: "1",
			},
			{
				text: "User management according to roles and privileges",
				column: "1",
			},
			{
				text: "Location data, speed, direction and more",
				column: "1",
			},
			{
				text: "Internet based software, Google Maps or OSM",
				column: "1",
			},
			{
				text: "Creation and monitoring of points of interest and geofences",
				column: "1",
			},
			{
				text: "Travel reports, speed, time of use, working hours, and much more",
				column: "2",
			},
			{
				text: "Number of kilometers per day, week, or month",
				column: "2",
			},
			{
				text: "Customizable infraction alerts",
				column: "2",
			},
			{
				text: "Fuel management",
				column: "2",
			},
			{
				text: "Maintenance report and management",
				column: "2",
			},
			{
				text: "Fuel consumption",
				column: "2",
			},
			{
				text: "Alerts and events by email, SMS, or push notifications",
				column: "2",
			},
			{
				text: "Platform use training",
				column: "2",
			},
			{
				text: "24/7 support",
				column: "2",
			},
			{
				text: "Integration of multiple sensors regardless of model and brand",
				column: "2",
			},
			{
				text: "Real time drive diagnostic dashboard",
				column: "2",
			},
			{
				text: "Preventive maintenance schedule",
				column: "2",
			},
			{
				text: "Solutions for concrete mixers",
				column: "2",
			},
		],
		form_title: "We want to help you, contact us now",
		form_button_text: "SEND YOUR SUMMARY",
		form_fields: [
			{
				title: "Name:",
				requestKey: "nombre",
			},
			{
				title: "Email:",
				requestKey: "email",
			},
			{
				title: "Country:",
				requestKey: "pais",
			},
			{
				title: "Last Name:",
				requestKey: "apellido",
			},
			{
				title: "Phone Number:",
				requestKey: "movil",
			},
			{
				title: "Company:",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "Subject:",
				requestKey: "asunto",
			},
		],
	},
};

export default language;
